import { Fragment } from "@tiptap/pm/model";
import { type Command, NodeSelection } from "@tiptap/pm/state";

export const convertInlineImageToBlock: Command = (state, dispatch) => {
	const { selection, schema } = state;
	if (!(selection instanceof NodeSelection) || selection.node.type.name !== "inlineImage") return false;
	const { $from, node } = selection;
	if ($from.parent.type.name !== "paragraph" || !schema.nodes.image) return false;
	const before = $from.parent.cut(0, $from.parentOffset);
	const after = $from.parent.cut($from.parentOffset + node.nodeSize);
	const image = schema.nodes.image.create(node.attrs);
	const content = Fragment.fromArray([
		...(before.content.size ? [before] : []),
		image,
		...(after.content.size ? [after] : []),
	]);
	const start = $from.before();
	if (!$from.node(-1).canReplace($from.index(-1), $from.index(-1) + 1, content)) return false;
	if (dispatch) {
		const tr = state.tr.replaceWith(start, $from.after(), content);
		tr.setSelection(NodeSelection.create(tr.doc, start + (before.content.size ? before.nodeSize : 0)));
		dispatch(tr.scrollIntoView());
	}
	return true;
};
